import {
    BATTERY_PRODUCT_CAR_BEST_SELLER_AMPERES,
    BATTERY_PRODUCT_MOTOR_BEST_SELLER_AMPERES,
    CAR_BATTERY_VEHICLE_TYPE_ID,
    MOTOR_BATTERY_VEHICLE_TYPE_ID
} from '@/constants/batteryProduct';
import { vehicleTypesCategoryId } from '@/constants/common';
import { carBatteryLanding, motorBatteryLanding } from '@/constants/routes';

export const BATTERY_LANDING_PRODUCTS_PAGE_SIZE = 500;
export const BATTERY_LANDING_REVALIDATE_SECONDS = 60;
export const BATTERY_LANDING_HIDDEN_DISCOUNT_PERCENTAGE = 99;
export const BATTERY_LANDING_LIST_ID = 'battery-list';
export const BATTERY_LANDING_AMPERE_LIST_ID = 'battery-ampere-list';
export const BATTERY_LANDING_MAX_CARD_BADGES = 3;
export const BATTERY_LANDING_CARD_VISIBLE_BADGES = 2;

export const BATTERY_LANDING_DEFAULT_VARIANT = { height: 'SHORT', pole: 'L' } as const;

export const batteryLandingPriceBasis = {
    badge: 'شفافیت قیمت',
    title: 'قیمت نهایی چطور حساب می‌شود؟',
    subtitle: 'قیمت‌ها برای تعویض با باتری قدیمی هم‌آمپر است. کارشناس در محل آمپر باتری قدیمی شما را اندازه می‌گیرد.',
    strip: 'قیمت‌ها برای تعویض با باتری قدیمی هم‌آمپر است.'
};

export const priceBasisRules = [
    { id: 'same', title: 'باتری قدیمی هم‌آمپر', description: 'همان قیمت کارت. مبلغ دیگری نمی‌پردازید.' },
    {
        id: 'lower',
        title: 'آمپر کمتر یا بدون باتری قدیمی',
        description:
            'برای هر آمپر اختلاف، مبلغی بر اساس نرخ هر آمپر به قیمت اضافه می‌شود. بدون باتری قدیمی، کل آمپر باتری جدید در این نرخ ضرب می‌شود.'
    },
    {
        id: 'higher',
        title: 'آمپر بیشتر',
        description: 'مابه‌التفاوت به کیف پول شما برمی‌گردد و بعد از اتمام سفارش می‌توانید درخواست برداشت وجه ثبت کنید.'
    }
];

export const deliveryTripFee = {
    title: 'ارسال و نصب رایگان، بدون هیچ هزینه‌ی پنهان',
    description:
        'قیمتی که روی کارت می‌بینی همان مبلغ نهایی است؛ ارسال، نصب و تحویل باتری قدیمی رایگان است و هزینه‌ی جانبی دیگری نمی‌پردازی. فقط اگر کارشناس با دستگاه تستر نشان بدهد باتری فعلی‌ات سالم است و نیازی به تعویض ندارد، تنها هزینه‌ی ایاب‌ذهاب کارشناس دریافت می‌شود.',
    highlights: ['ارسال و نصب رایگان', 'پرداخت فقط مبلغ نهایی', 'بدون هزینه‌ی جانبی', 'باتری سالم؟ فقط ایاب‌ذهاب']
};

export const batteryCampaignVehicles: Record<string, { name: string; description: string }> = {
    pride: { name: 'پراید', description: 'برای پراید ۱۱۱، ۱۳۱، ۱۳۲ و وانت، مدل و تیپ دقیق را انتخاب کن و آمپر پیشنهادی را ببین.' },
    '206': { name: 'پژو ۲۰۶', description: 'برای انواع پژو ۲۰۶، از تیپ ۲ تا تیپ ۵، مشخصات باتری پیشنهادی را با انتخاب تیپ خودرو ببین.' },
    '207': { name: 'پژو ۲۰۷', description: 'باتری مناسب پژو ۲۰۷ دنده‌ای و اتوماتیک را با انتخاب مدل و تیپ دقیق پیدا کن.' },
    '405': { name: 'پژو ۴۰۵', description: 'برای انتخاب باتری پژو ۴۰۵، نوع موتور و تیپ خودرو را مشخص کن.' },
    pars: { name: 'پژو پارس', description: 'مدل و تیپ پژو پارس را انتخاب کن تا آمپرهای پیشنهادی باتری را ببینی.' },
    saina: { name: 'ساینا', description: 'با انتخاب تیپ ساینا، مشخصات باتری مناسب ماشینت را ببین.' },
    samand: { name: 'سمند', description: 'مدل و تیپ سمند را مشخص کن تا باتری مناسب آن را راحت‌تر انتخاب کنی.' },
    tiba: { name: 'تیبا', description: 'مدل و تیپ تیبا را انتخاب کن و آمپرهای پیشنهادی باتری را ببین.' },
    quik: { name: 'کوییک', description: 'برای انتخاب باتری کوییک، مدل و تیپ دقیق ماشینت را مشخص کن.' },
    dena: { name: 'دنا', description: 'مشخصات باتری مناسب دنا و دنا پلاس را با انتخاب مدل و تیپ دقیق ببین.' },
    rana: { name: 'رانا', description: 'با انتخاب مدل و تیپ رانا، آمپرهای پیشنهادی باتری را ببین.' },
    other: { name: 'خودروی شما', description: 'مدل ماشینت را جست‌وجو کن؛ اگر پیدایش نکردی، برای راهنمایی انتخاب باتری با پشتیبانی تماس بگیر.' }
};

export const batteryCampaignBrands: Record<string, { name: string; description: string }> = {
    saba: { name: 'صبا', description: 'مدل‌های موجود صبا باتری را با قیمت روز و مدت گارانتی هر محصول مقایسه کن؛ با ارسال و نصب رایگان در محل.' },
    orbital: { name: 'سپاهان (اوربیتال)', description: 'باتری‌های اوربیتال سپاهان را بر اساس آمپر، قیمت و گارانتی مقایسه کن؛ با نصب در محل شما.' },
    varian: { name: 'واریان پلاس', description: 'مدل‌های موجود واریان را با آمپر و گارانتی هر محصول ببین؛ با امکان خرید در ۴ قسط.' }
};

export const batteryCampaignCities: Record<string, string> = {
    tehran: 'تهران',
    karaj: 'کرج',
    mashhad: 'مشهد',
    isfahan: 'اصفهان',
    rasht: 'رشت',
    yazd: 'یزد',
    shiraz: 'شیراز'
};

export const batteryLandingContent = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: {
        categoryId: vehicleTypesCategoryId.CAR,
        landingRoute: carBatteryLanding,
        bestSellerAmperes: BATTERY_PRODUCT_CAR_BEST_SELLER_AMPERES,
        bestSellerBrandKeyword: 'صبا',
        hasPoleSpec: true,
        minComparableProducts: 2,
        hasDeliveryTerms: true,
        meta: {
            title: 'خرید باتری ماشین با نصب رایگان در محل | قیمت و گارانتی',
            description:
                'قیمت باتری ماشین صبا، آکو باتری، اوربیتال و سوزوکی با گارانتی مشخص هر محصول. ارسال و نصب رایگان در محل، پرداخت اقساطی و پشتیبانی ۷ تا ۲۳.',
            ogImage: '/images/homeSlider/banner-battery.webp'
        },
        hero: {
            badge: 'ارسال و نصب رایگان در محل',
            title: 'خرید و تعویض باتری ماشین در محل',
            highlightedTitle: 'ارسال و نصب رایگان، در محل شما',
            description: 'باتری نو با گارانتی شرکتی و امکان خرید قسطی. تکنسین ما باتری را به محل شما می‌آورد و رایگان نصب می‌کند.',
            primaryCta: 'ثبت سفارش فوری',
            secondaryCta: 'پشتیبانی و راهنمایی'
        },
        preview: {
            title: 'باتری ماشین اصل',
            subtitle: 'برندهای معتبر • نصب در محل',
            status: 'تأیید شده',
            image: '/images/battery/saba-60ah.webp',
            imageAlt: 'باتری ماشین',
            items: ['ارسال به آدرس شما', 'نصب توسط کارشناس', 'تست با دستگاه تستر', 'تحویل باتری قدیمی'],
            guarantee: { title: 'گارانتی معتبر', subtitle: 'مدت مشخص روی هر محصول' },
            install: { title: 'ارسال و نصب رایگان', subtitle: 'در محل شما' }
        },
        trustItems: [
            { id: 'guarantee', title: 'گارانتی معتبر', description: 'مدت گارانتی هر مدل را روی کارت محصول و جدول برندها ببین.' },
            { id: 'install', title: 'ارسال و نصب رایگان', description: 'کارشناس باتری را به آدرس شما می‌آورد، نصب و تست می‌کند.' },
            { id: 'installment', title: 'پرداخت اقساطی', description: 'امکان خرید در ۴ قسط.' },
            { id: 'support', title: 'پشتیبانی همه‌روزه', description: 'از ساعت ۷ تا ۲۳ پاسخگوی شما هستیم.' }
        ],
        sections: {
            brandComparison: {
                badge: 'انتخاب بر اساس برند',
                title: 'باتری ماشین را بر اساس برند انتخاب کن',
                subtitle: 'برند مورد نظرت را انتخاب کن تا همه‌ی آمپرهای موجود آن را ببینی.',
                listTitle: 'برندهای باتری ماشین'
            },
            comparison: {
                badge: 'مقایسه‌ی برندها',
                title: 'باتری مناسب ماشینت را انتخاب کن',
                subtitle: 'آمپر باتری قدیمی ماشینت را انتخاب کن (روی برچسب باتری نوشته شده) تا برندها را کنار هم ببینی.',
                listTitle: 'باتری ماشین'
            },
            steps: {
                badge: 'مراحل سفارش',
                title: 'سفارش باتری در چهار قدم',
                subtitle: 'بدون جابه‌جایی ماشین و بدون مراجعه به تعمیرگاه.'
            },
            faq: {
                badge: 'سوالات متداول',
                title: 'سوالات پرتکرار درباره‌ی خرید باتری ماشین'
            },
            finalCta: {
                badge: 'ارسال و نصب رایگان در محل',
                title: 'هنوز مطمئن نیستی کدام باتری مناسب ماشین توست؟',
                subtitle: 'با پشتیبانی تماس بگیر تا بر اساس مدل ماشین راهنمایی‌ات کنند؛ همه‌روزه از ۷ تا ۲۳ پاسخگوی تو هستیم.',
                ctaLabel: 'مشاهده‌ی قیمت باتری‌ها',
                relatedLabel: 'سوالی داری یا کمک می‌خواهی؟'
            }
        },
        schemaListName: 'باتری ماشین',
        steps: [
            { id: 'request', title: 'ثبت سفارش', description: 'ماشین و باتری را انتخاب کن، آدرس و زمان نصب را مشخص کن.' },
            { id: 'confirm', title: 'هماهنگی و تایید', description: 'کارشناس نصب برای هماهنگی نهایی با شما تماس می‌گیرد.' },
            { id: 'visit', title: 'اعزام کارشناس', description: 'کارشناس با تجهیزات کامل به محل ماشین شما می‌آید. نیازی به جابه‌جایی ماشین نیست.' },
            {
                id: 'install',
                title: 'تحویل، نصب و تست باتری',
                description: 'باتری جدید نصب می‌شود؛ تست باتری و دینام رایگان است و باتری کهنه (داغی) تحویل گرفته می‌شود.'
            }
        ],
        faq: []
    },
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: {
        categoryId: vehicleTypesCategoryId.MOTORCYCLE,
        landingRoute: motorBatteryLanding,
        bestSellerAmperes: [...BATTERY_PRODUCT_MOTOR_BEST_SELLER_AMPERES].sort((first, second) => second - first),
        bestSellerBrandKeyword: '',
        hasPoleSpec: false,
        minComparableProducts: 3,
        hasDeliveryTerms: true,
        meta: {
            title: 'خرید باتری موتورسیکلت با نصب رایگان در محل | قیمت و گارانتی',
            description: 'قیمت باتری موتورسیکلت با گارانتی معتبر شرکتی. ارسال و نصب رایگان در محل در تهران، مشاوره‌ی رایگان و پشتیبانی ۷ تا ۲۳.',
            ogImage: '/images/homeSlider/banner-battery.webp'
        },
        hero: {
            badge: 'ارسال و نصب رایگان در تهران',
            title: 'خرید و تعویض باتری موتورسیکلت',
            highlightedTitle: 'با نصب رایگان در محل',
            description:
                'باتری نو با گارانتی شرکتی، امکان خرید در ۴ قسط و تخفیف تحویل باتری کهنه. کارشناس باتری را در تهران به آدرس تو می‌آورد و نصب می‌کند.',
            primaryCta: 'ثبت درخواست',
            secondaryCta: 'پشتیبانی و راهنمایی'
        },
        preview: {
            title: 'باتری موتورسیکلت',
            subtitle: 'گارانتی معتبر • نصب در محل',
            status: 'تأیید شده',
            image: '/images/battery/tinoo-7ah-s.webp',
            imageAlt: 'باتری موتورسیکلت',
            items: ['ارسال به آدرس شما', 'نصب توسط کارشناس', 'تحویل باتری قدیمی', 'مشاوره‌ی رایگان'],
            guarantee: { title: 'گارانتی معتبر', subtitle: 'ضمانت شرکتی' },
            install: { title: 'ارسال و نصب رایگان', subtitle: 'در تهران' }
        },
        trustItems: [
            { id: 'guarantee', title: 'گارانتی معتبر', description: 'باتری‌ها با گارانتی معتبر شرکتی عرضه می‌شوند.' },
            { id: 'install', title: 'ارسال و نصب رایگان', description: 'کارشناس باتری را در تهران به آدرس شما می‌آورد و نصب می‌کند.' },
            { id: 'consult', title: 'مشاوره‌ی رایگان', description: 'برای انتخاب باتری مناسب موتورت با پشتیبانی مشورت کن.' },
            { id: 'support', title: 'پشتیبانی همه‌روزه', description: 'از ساعت ۷ تا ۲۳ پاسخگوی شما هستیم.' }
        ],
        sections: {
            brandComparison: {
                badge: 'انتخاب بر اساس برند',
                title: 'باتری موتورسیکلت را بر اساس برند انتخاب کن',
                subtitle: 'برند مورد نظرت را انتخاب کن تا همه‌ی آمپرهای موجود آن را ببینی.',
                listTitle: 'برندهای باتری موتورسیکلت'
            },
            comparison: {
                badge: 'مقایسه‌ی برندها',
                title: 'باتری مناسب موتورت را انتخاب کن',
                subtitle: 'آمپر باتری قدیمی موتورت را انتخاب کن (روی برچسب باتری نوشته شده) تا برندها را کنار هم ببینی.',
                listTitle: 'باتری موتورسیکلت'
            },
            steps: {
                badge: 'مراحل سفارش',
                title: 'سفارش باتری در چهار قدم',
                subtitle: 'بدون جابه‌جایی موتورسیکلت و بدون مراجعه به تعمیرگاه.'
            },
            faq: {
                badge: 'سوالات متداول',
                title: 'سوالات پرتکرار درباره‌ی خرید باتری موتورسیکلت'
            },
            finalCta: {
                badge: 'ارسال و نصب رایگان در تهران',
                title: 'هنوز مطمئن نیستی کدام باتری مناسب موتور توست؟',
                subtitle: 'با پشتیبانی تماس بگیر تا بر اساس مدل موتورسیکلت راهنمایی‌ات کنند؛ همه‌روزه از ۷ تا ۲۳ پاسخگوی تو هستیم.',
                ctaLabel: 'مشاهده‌ی قیمت باتری‌ها',
                relatedLabel: 'سوالی داری یا کمک می‌خواهی؟'
            }
        },
        schemaListName: 'باتری موتورسیکلت',
        steps: [
            { id: 'request', title: 'ثبت سفارش', description: 'موتورسیکلت و باتری را انتخاب کن، آدرس و زمان نصب را مشخص کن.' },
            { id: 'confirm', title: 'هماهنگی و تایید', description: 'کارشناس نصب برای هماهنگی نهایی با شما تماس می‌گیرد.' },
            { id: 'visit', title: 'اعزام کارشناس', description: 'کارشناس با تجهیزات کامل به محل شما می‌آید. نیازی به مراجعه به تعمیرگاه نیست.' },
            { id: 'install', title: 'تحویل و نصب', description: 'باتری جدید نصب می‌شود و باتری قدیمی تحویل گرفته می‌شود.' }
        ],
        faq: []
    }
};

export const batteryBadgeLabels = {
    suggested: 'پیشنهاد ازکی‌سرویس',
    bestSellerBrand: 'پرفروش‌ترین برند',
    cheapest: 'اقتصادی‌ترین',
    premium: 'پریمیوم',
    longestGuarantee: 'بیشترین گارانتی',
    bestValue: 'بهترین ارزش'
} as const;
